import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkReferentialWhitelist } from './referential-access-api';

export const checkReferentialWhitelistThunk = createAsyncThunk<
    any,
    { ecrId: string }
>(
    'referential-access/checkReferentialWhitelist',
    async ({ ecrId }: { ecrId: string }, { rejectWithValue }) => {
        try {
            const response = await checkReferentialWhitelist(ecrId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
